import { getNextDates } from '../utils/cartUtils';
import { getApiDateFormat } from '../utils/commonUtils';

export const googleAnalyticsPropertyId = 'UA-23349176-1';
export const googleTagManagerApiKey = 'GTM-WH65K8X';
export const facebookPixelId = '1606551582691392';
export const sentryDnsKey =
  'https://07008e78910347adae4595b3510a1c81@sentry.io/1497842';

export const MONTH_TEXT_MAP = {
  1: 'January',
  2: 'February',
  3: 'March',
  4: 'April',
  5: 'May',
  6: 'June',
  7: 'July',
  8: 'August',
  9: 'September',
  10: 'October',
  11: 'November',
  12: 'December',
};

export const CDN_CLRSAVE_URL = 'https://assets1.cleartax-cdn.com';

export const enum Direction {
  SIP = 'SIP_MF',
  LUMPSUM = 'LUMPSUM_MF',
}

export const MAX_MF_INVEST_IN_LUMPSUM = 1000000;
export const MAX_MF_INVEST_IN_SIP = 150000;

export const SHORT_TERM = 'SHORT_TERM';
export const LONG_TERM = 'LONG_TERM';
export const MEDIUM_TERM = 'MEDIUM_TERM';
export const ELSS = 'ELSS';
export const NON_ELSS = 'NON ELSS';
export const LIQUID = 'LIQUID';

export const INVESTMENT_TYPE_LABEL = {
  [ELSS]: {
    [Direction.SIP]: 'SIP_TAX',
    [Direction.LUMPSUM]: 'LUMPSUM_TAX',
  },
  [NON_ELSS]: {
    [Direction.SIP]: {
      [SHORT_TERM]: 'SIP_SHORT',
      [LONG_TERM]: 'SIP_LONG',
    },
    [Direction.LUMPSUM]: {
      [SHORT_TERM]: 'LUMPSUM_SHORT',
      [LONG_TERM]: 'LUMPSUM_LONG',
    },
  },
};

export const COMMON_SIP_DATE = ['10'];

export const AMOUNT_SELECTION_FIELDS = [
  {
    name: 'amount',
    labelName: 'Amount to Invest',
    type: 'text',
    isInvalid: false,
    required: false,
    className: 'large-10 small-8 columns',
    as: 'pan',
    value: '',
  },

  {
    name: 'investmentType',
    labelName: 'Mode of Investment',
    type: 'radio',
    isInvalid: false,
    required: true,
    value: Direction.SIP,
    className: 'large-12 small-12 columns',
    options: [
      {
        label: 'Monthly (SIP)',
        value: Direction.SIP,
      },
      {
        label: 'One Time',
        value: Direction.LUMPSUM,
      },
    ],
  },

  {
    name: 'date',
    labelName: 'Next SIP installment date',
    type: 'select',
    isInvalid: false,
    required: false,
    className: 'large-12 small-12 columns',
    value: '',
    options: getNextDates().map((dateObj) => {
      return {
        label: getApiDateFormat(dateObj),
        value: dateObj.toDateString(),
      };
    }),
    hideEmpty: true,
    isHidden: true,
  },
];

export function makeid() {
  let text = '';
  const possible =
    'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

  for (let i = 0; i < 5; i++) {
    text += possible.charAt(Math.floor(Math.random() * possible.length));
  }

  return text;
}

export const CUSTOM_ERROR = [
  {
    'Error Message sent by Billdesk': 'Funds transfer terminated by user.',
    'Error message for user': 'The funds transfer was terminated.',
    'Possible Solution': [
      'Check your payment details and try again.',
      'Try with a different payment method.',
      'Contact your bank to report the issue.',
    ],
    'Retry Button': 'Yes',
    'Go to home': 'No',
    'Edit Plan': 'Yes',
  },
  {
    'Error Message sent by Billdesk': 'Payment not authorized',
    'Error message for user': 'The transaction was refused by your bank.',
    'Possible Solution': [
      'Check your payment details and try again.',
      'Try with a different payment method.',
      'Contact your bank to report the issue.',
    ],
    'Retry Button': 'Yes',
    'Go to home': 'No',
    'Edit Plan': 'Yes',
  },
  {
    'Error Message sent by Billdesk':
      'Sorry, you do not have sufficient funds to carry out this instruction.',
    'Error message for user':
      'You do not have sufficient funds in your bank account for this investment',
    'Possible Solution': [
      'Add sufficient funds to your bank account',
      'Try with a smaller amount.',
    ],
    'Retry Button': 'No',
    'Go to home': 'Yes',
    'Edit Plan': 'Yes',
  },
  {
    'Error Message sent by Billdesk': 'Failure. Transaction not attempted',
    'Error message for user': 'The funds transfer was terminated.',
    'Possible Solution': [
      'Check your payment details and try again.',
      'Try with a different payment method.',
      'Contact your bank to report the issue.',
    ],
    'Retry Button': 'Yes',
    'Go to home': 'No',
    'Edit Plan': 'Yes',
  },
  {
    'Error Message sent by Billdesk': 'SUCCESS',
    'Error message for user': '',
    'Possible Solution': [''],
    'Retry Button': '',
    'Go to home': '',
    'Edit Plan': '',
  },
  {
    'Error Message sent by Billdesk':
      'Sorry! Your transaction has been cancelled',
    'Error message for user': 'The funds transfer was terminated.',
    'Possible Solution': [
      'Check your payment details and try again.',
      'Try with a different payment method.',
      'Contact your bank to report the issue.',
    ],
    'Retry Button': 'Yes',
    'Go to home': 'No',
    'Edit Plan': 'Yes',
  },
  {
    'Error Message sent by Billdesk':
      'You have exceeded your third party funds transfer limit for the day. You cannot transfer any more funds.',
    'Error message for user':
      'You have exceeded your third party funds transfer limit for the day. You cannot transfer any more funds.',
    'Possible Solution': [
      'Check your payment details and try again tomorrow.',
      'Contact your bank to report the issue.',
    ],
    'Retry Button': 'No',
    'Go to home': 'Yes',
    'Edit Plan': 'Yes',
  },
  {
    'Error Message sent by Billdesk':
      'YOU ARE NOT AUTHORIZED TO DO THIS TRANSACTION. PLEASE LOGIN TO HDFC BANK NETBANKING TO RESET YOUR PROFILE USING  MODIFY SECURE ACCESS PROFILE  OR CONTACT HDFC BANK PHONEBANKING FOR FURTHER DETAILS.',
    'Error message for user': 'The transaction was refused by your bank.',
    'Possible Solution': [
      'Check your payment details and try again.',
      'Try with a different payment method.',
      'Contact your bank to report the issue.',
    ],
    'Retry Button': 'Yes',
    'Go to home': 'No',
    'Edit Plan': 'Yes',
  },
  {
    'Error Message sent by Billdesk': 'Transaction not authorized',
    'Error message for user': 'The transaction was refused by your bank.',
    'Possible Solution': [
      'Check your payment details and try again.',
      'Try with a different payment method.',
      'Contact your bank to report the issue.',
    ],
    'Retry Button': 'Yes',
    'Go to home': 'No',
    'Edit Plan': 'Yes',
  },
  {
    'Error Message sent by Billdesk': 'failure',
    'Error message for user': 'The funds transfer was terminated.',
    'Possible Solution': [
      'Check your payment details and try again.',
      'Try with a different payment method.',
      'Contact your bank to report the issue.',
    ],
    'Retry Button': 'Yes',
    'Go to home': 'No',
    'Edit Plan': 'Yes',
  },
  {
    'Error Message sent by Billdesk':
      'Transaction failed.TPT/Secure access facility not registered. Please login to NetBanking and click on Third Party Transfer Tab to register or contact phone Banking/nearest branch for more details',
    'Error message for user': 'The transaction was refused by your bank.',
    'Possible Solution': [
      'Third Party Funds Transfer facility not registered.',
      'Contact your bank to report the issue.',
      'Try with a different payment method.',
    ],
    'Retry Button': 'No',
    'Go to home': 'Yes',
    'Edit Plan': 'Yes',
  },
  {
    'Error Message sent by Billdesk': 'Cancelled',
    'Error message for user': 'The funds transfer was terminated.',
    'Possible Solution': [
      'Check your payment details and try again.',
      'Try with a different payment method.',
      'Contact your bank to report the issue.',
    ],
    'Retry Button': 'Yes',
    'Go to home': 'No',
    'Edit Plan': 'Yes',
  },
  {
    'Error Message sent by Billdesk':
      'Third Party Funds Transfer facility not registered. Please contact Phone banking or visit nearest branch for more details.',
    'Error message for user': 'The transaction was refused by your bank.',
    'Possible Solution': [
      'Third Party Funds Transfer facility not registered.',
      'Contact your bank to report the issue.',
      'Try with a different payment method.',
    ],
    'Retry Button': 'No',
    'Go to home': 'Yes',
    'Edit Plan': 'Yes',
  },
  {
    'Error Message sent by Billdesk': 'RECORD NOT FOUND',
    'Error message for user': 'The funds transfer was terminated.',
    'Possible Solution': [
      'Check your payment details and try again.',
      'Try with a different payment method.',
      'Contact your bank to report the issue.',
    ],
    'Retry Button': 'Yes',
    'Go to home': 'No',
    'Edit Plan': 'Yes',
  },
  {
    'Error Message sent by Billdesk': 'Canceled By User',
    'Error message for user': 'The funds transfer was terminated.',
    'Possible Solution': [
      'Check your payment details and try again.',
      'Try with a different payment method.',
      'Contact your bank to report the issue.',
    ],
    'Retry Button': 'Yes',
    'Go to home': 'No',
    'Edit Plan': 'Yes',
  },
  {
    'Error Message sent by Billdesk': 'PBE10002-Do not honour',
    'Error message for user': 'The transaction was refused by your bank.',
    'Possible Solution': [
      'Check your payment details and try again.',
      'Try with a different payment method.',
      'Contact your bank to report the issue.',
    ],
    'Retry Button': 'Yes',
    'Go to home': 'No',
    'Edit Plan': 'Yes',
  },
  {
    'Error Message sent by Billdesk':
      'PBE10002-Unable to process internal error',
    'Error message for user':
      'We are facing some issue in processing this transaction',
    'Possible Solution': ['Please try again after sometime.'],
    'Retry Button': 'No',
    'Go to home': 'Yes',
    'Edit Plan': 'No',
  },
  {
    'Error Message sent by Billdesk':
      'We were unable to put through this transaction owing to network errors.',
    'Error message for user':
      'We are facing some issue in processing this transaction',
    'Possible Solution': ['Please try again after sometime.'],
    'Retry Button': 'No',
    'Go to home': 'Yes',
    'Edit Plan': 'No',
  },
  {
    'Error Message sent by Billdesk':
      'PME10013-3D Secure Authentication failure',
    'Error message for user': 'The transaction was refused by your bank.',
    'Possible Solution': [
      'Check your payment details and try again.',
      'Try with a different payment method.',
      'Contact your bank to report the issue.',
    ],
    'Retry Button': 'Yes',
    'Go to home': 'No',
    'Edit Plan': 'Yes',
  },
  {
    'Error Message sent by Billdesk': 'PBE10002-Invalid Credential',
    'Error message for user': 'The transaction was refused by your bank.',
    'Possible Solution': [
      'Check your payment details and try again.',
      'Try with a different payment method.',
      'Contact your bank to report the issue.',
    ],
    'Retry Button': 'Yes',
    'Go to home': 'No',
    'Edit Plan': 'Yes',
  },
  {
    'Error Message sent by Billdesk': 'PME10014-Connection timedout',
    'Error message for user': 'The funds transfer was terminated.',
    'Possible Solution': [
      'Check your payment details and try again.',
      'Try with a different payment method.',
      'Contact your bank to report the issue.',
    ],
    'Retry Button': 'Yes',
    'Go to home': 'No',
    'Edit Plan': 'Yes',
  },
  {
    'Error Message sent by Billdesk': 'PBE10002-Invalid transaction on card',
    'Error message for user':
      'The transaction on the card was refused by your bank.',
    'Possible Solution': [
      'Check your payment details and try again.',
      'Try with a different payment method.',
      'Contact your bank to report the issue.',
    ],
    'Retry Button': 'Yes',
    'Go to home': 'No',
    'Edit Plan': 'Yes',
  },
  {
    'Error Message sent by Billdesk': 'PBE10002-Error account problem',
    'Error message for user': 'The transaction was refused by your bank.',
    'Possible Solution': [
      'Check your payment details and try again.',
      'Try with a different payment method.',
      'Contact your bank to report the issue.',
    ],
    'Retry Button': 'Yes',
    'Go to home': 'No',
    'Edit Plan': 'Yes',
  },
  {
    'Error Message sent by Billdesk': 'PBE10002-Unable to process',
    'Error message for user': 'The funds transfer was terminated.',
    'Possible Solution': [
      'Check your payment details and try again.',
      'Try with a different payment method.',
      'Contact your bank to report the issue.',
    ],
    'Retry Button': 'Yes',
    'Go to home': 'No',
    'Edit Plan': 'Yes',
  },
  {
    'Error Message sent by Billdesk': 'Error while processing',
    'Error message for user': 'The funds transfer was terminated.',
    'Possible Solution': [
      'Check your payment details and try again.',
      'Try with a different payment method.',
      'Contact your bank to report the issue.',
    ],
    'Retry Button': 'Yes',
    'Go to home': 'No',
    'Edit Plan': 'Yes',
  },
  {
    'Error Message sent by Billdesk':
      'PBE10002-Transaction not permitted to cardholder',
    'Error message for user':
      'The transaction on the card was refused by your bank.',
    'Possible Solution': [
      'Check your payment details and try again.',
      'Try with a different payment method.',
      'Contact your bank to report the issue.',
    ],
    'Retry Button': 'Yes',
    'Go to home': 'No',
    'Edit Plan': 'Yes',
  },
  {
    'Error Message sent by Billdesk': 'PBE10002-Insufficient funds',
    'Error message for user':
      'You do not have sufficient funds in your bank account for this investment',
    'Possible Solution': [
      'Add sufficient funds to your bank account',
      'Try with a smaller amount.',
    ],
    'Retry Button': 'No',
    'Go to home': 'Yes',
    'Edit Plan': 'Yes',
  },
  {
    'Error Message sent by Billdesk': 'PBE10002-Invalid expiry or cvv2 value',
    'Error message for user': 'The transaction was refused by your bank.',
    'Possible Solution': [
      'Check your payment details and try again.',
      'Try with a different payment method.',
      'Contact your bank to report the issue.',
    ],
    'Retry Button': 'Yes',
    'Go to home': 'No',
    'Edit Plan': 'Yes',
  },
  {
    'Error Message sent by Billdesk': 'PBE10002-Unable to authorize',
    'Error message for user': 'The transaction was refused by your bank.',
    'Possible Solution': [
      'Check your payment details and try again.',
      'Try with a different payment method.',
      'Contact your bank to report the issue.',
    ],
    'Retry Button': 'Yes',
    'Go to home': 'No',
    'Edit Plan': 'Yes',
  },
  {
    'Error Message sent by Billdesk': 'NA',
    'Error message for user':
      'We are facing some issue in processing this transaction',
    'Possible Solution': ['Please contact ClearTax support'],
    'Retry Button': 'No',
    'Go to home': 'Yes',
    'Edit Plan': 'No',
  },
  {
    'Error Message sent by Billdesk':
      'Merchant transaction is cancelled by user',
    'Error message for user': 'The funds transfer was terminated.',
    'Possible Solution': [
      'Check your payment details and try again.',
      'Try with a different payment method.',
      'Contact your bank to report the issue.',
    ],
    'Retry Button': 'Yes',
    'Go to home': 'No',
    'Edit Plan': 'Yes',
  },
  {
    'Error Message sent by Billdesk': 'Insufficient funds.',
    'Error message for user':
      'You do not have sufficient funds in your bank account for this investment',
    'Possible Solution': [
      'Add sufficient funds to your bank account',
      'Try with a smaller amount',
    ],
    'Retry Button': 'No',
    'Go to home': 'Yes',
    'Edit Plan': 'Yes',
  },
  {
    'Error Message sent by Billdesk': 'PME10005-Invalid issuer response',
    'Error message for user': 'The transaction was refused by your bank.',
    'Possible Solution': [
      'Check your payment details and try again.',
      'Try with a different payment method.',
      'Contact your bank to report the issue.',
    ],
    'Retry Button': 'Yes',
    'Go to home': 'No',
    'Edit Plan': 'Yes',
  },
  {
    'Error Message sent by Billdesk':
      'PME10009-Card holder or issuing bank not3D enrolled',
    'Error message for user': 'The transaction was refused by your bank.',
    'Possible Solution': [
      'Check your payment details and try again.',
      'Try with a different payment method.',
      'Contact your bank to report the issue.',
    ],
    'Retry Button': 'Yes',
    'Go to home': 'No',
    'Edit Plan': 'Yes',
  },
  {
    'Error Message sent by Billdesk': 'other',
    'Error message for user': 'The funds transfer was terminated.',
    'Possible Solution': [
      'Check your payment details and try again.',
      'Try with a different payment method.',
      'Contact your bank to report the issue.',
    ],
    'Retry Button': 'Yes',
    'Go to home': 'No',
    'Edit Plan': 'Yes',
  },
  {
    'Error Message sent by Billdesk': 'PME10002-Card not enrolled for3dsecure',
    'Error message for user': 'The transaction was refused by your bank.',
    'Possible Solution': [
      'Check your payment details and try again.',
      'Try with a different payment method.',
      'Contact your bank to report the issue.',
    ],
    'Retry Button': 'Yes',
    'Go to home': 'No',
    'Edit Plan': 'Yes',
  },
  {
    'Error Message sent by Billdesk': 'NA',
    'Error message for user':
      'We are facing some issue in processing this transaction',
    'Possible Solution': ['Please contact ClearTax support'],
    'Retry Button': 'No',
    'Go to home': 'Yes',
    'Edit Plan': 'No',
  },
  {
    'Error Message sent by Billdesk': 'Timeout',
    'Error message for user': 'The funds transfer was terminated.',
    'Possible Solution': ['Please contact ClearTax support'],
    'Retry Button': 'No',
    'Go to home': 'Yes',
    'Edit Plan': 'No',
  },
  {
    'Error Message sent by Billdesk': 'Completed successfully',
    'Error message for user': '',
    'Possible Solution': [''],
    'Retry Button': 'No',
    'Go to home': 'Yes',
    'Edit Plan': 'No',
  },
  {
    'Error Message sent by Billdesk': 'Invalid bank response',
    'Error message for user': 'The funds transfer was terminated.',
    'Possible Solution': ['Please contact ClearTax support'],
    'Retry Button': 'No',
    'Go to home': 'Yes',
    'Edit Plan': 'No',
  },
];

export const DEFAULT_PAYMENT_ERROR = {
  'Error message for user': 'Unknown error',
  'Possible Solution': [
    'Check your payment details and try again.',
    'Try with a different payment method.',
    'Contact your bank to report the issue.',
    'Please contact ClearTax support',
  ],
  'Retry Button': 'Yes',
  'Go to home': 'Yes',
  'Edit Plan': 'Yes',
};

export const ORIGINAL_ERROR = 'Error Message sent by Billdesk';
export const SHOWN_ERROR = 'Error message for user';
export const SOLUTION = 'Possible Solution';
export const RETRY_BUTTON = 'Retry Button';
export const GO_HOME = 'Go to home';
export const EDIT_PLAN = 'Edit Plan';

export const MUTUAL_FUND_RISK_INFO = `Mutual fund investments are subject to market risk and the past
performance of a fund does not guarantee future results or
returns. Keep in mind that while diversification may help spread
risk it does not assure a profit, or protect against loss, in a
down market. There is always the potential of losing money when
you invest in securities, or other financial products. Investors
should consider their investment objectives and risks carefully
before investing.`;

export const enum KYCStatus {
  VERIFIED = 'VERIFIED',
  NOT_VERIFIED = 'NOT_VERIFIED',
  NOT_KNOWN = 'NOT_KNOWN',
  UNDER_PROCESS = 'UNDER_PROCESS',
  THIRD_PARTY_FAILURE = 'THIRD_PARTY_FAILURE',
  UNABLE_TO_CHECK = 'UNABLE_TO_CHECK',
  NOT_AVAILABLE = 'NOT_AVAILABLE',
}

export const PAGE_TITLE = 'ClearTax Invest - Investment Made Simple';

export const PAGE_DESCRIPTION =
  'ClearTax Invest helps you to Invest in the best performing funds in 2021 & let your money grow through the power of compounding. Start your investment journey today!';

export const enum MANDATE_ENUM {
  EMANDATE = 'E_MANDATE',
  PAPER_NACH = 'PAPER_BASED',
}
export const SIP_INVESTMENT_TYPES = {
  name: 'Investment type ',
  id: 'investmentType',
  labelName: 'Expected Annual Returns (%)',
  type: 'select',
  isInvalid: false,
  value: '',
  options: [
    {
      label: '14%(Equity Mutual Funds)',
      value: 14,
    },
    {
      label: '8%(Debt Mutual Funds)',
      value: 8,
    },
  ],
  hideEmpty: true,
};

export const sipCalculatorGraphData = [0, 3, 6, 9, 12, 15, 18, 21, 24, 27, 30];

export const sipCalculatorGraphDataB = [0, 1, 3, 5, 10, 15, 20, 25, 30];

export const sipPoints = [
  {
    icon: 's/img/2018/05/28173021/pig.png',
    label: 'Invest in small amounts regularly',
    key: 'sip1',
  },
  {
    icon: 's/img/2018/06/07104400/returns.png',
    label: 'Opt for monthly auto-payment',
    key: 'sip2',
  },
  {
    icon: 's/img/2018/06/07104401/Growt.png',
    label: 'No worries about market ups & downs',
    key: 'sip3',
  },
  {
    icon: 's/img/2018/05/28173001/money-coins.png',
    label: 'Plan budget and expenses better',
    key: 'sip3',
  },
];

export const MANDATE_TYPE_URL_MAP = {
  E_MANDATE: 'create-razorpay/v2/DIRECT',
  PAPER_BASED: 'create-paper-mandate/DIRECT',
};

export const MANDATE_AMOUNT_ARR = [
  2000, 4000, 6000, 10000, 12000, 14000, 16000, 20000,
];

export const mandateAmountField = {
  name: 'mandateAmount',
  type: 'select',
  isInvalid: false,
  required: false,
  className: 'large-12 small-12 columns',
  hideEmpty: true,
  labelName: 'mandateAmount',
  id: 'mandateAmount',
};

export const mandateStatusesToShow = [
  'AUTHORIZED_BY_USER',
  'SUBMITTED_FOR_APPROVAL',
  'APPROVED',
  'REJECTED',
];

export const mandateStatusToReadableString = {
  AUTHORIZED_BY_USER: 'Waiting Mandate Approval From Bank',
  SUBMITTED_FOR_APPROVAL: 'Submitted for Approval',
  APPROVED: 'Activated',
  REJECTED: 'Mandate Rejected By Your Bank',
};

export const mandateStatusToClassName = {
  AUTHORIZED_BY_USER: 'pending',
  SUBMITTED_FOR_APPROVAL: 'pending',
  APPROVED: 'approved',
  REJECTED: 'rejected',
};

export const pendingKYCActionCard = {
  title: 'KYC Pending',
  subtitle: 'Mandatory to complete your investment',
  isImportant: true,
  ctaLabel: 'Complete your KYC',
  ctaLink: 'complete-kyc',
};

export const modifyKYCActionCard = {
  title: 'KYC Error',
  subtitle: 'Mandatory to complete your investment',
  isImportant: true,
  ctaLabel: 'Update your KYC',
  ctaLink: 'complete-kyc',
};
export const pendingMandateActionCard = {
  title: 'Mandate Pending',
  subtitle: 'One-time setup for automatic SIP debits',
  isImportant: true,
  ctaLabel: 'Start Setup',
  ctaLink: 'mandate',
};
export const pendingPennyDropCard = {
  title: 'Bank Verification',
  subtitle:
    'There appears to be some error in the bank details that you have provided to us',
  isImportant: true,
  ctaLabel: 'Verify Bank Details',
  ctaLink: 'profile',
};
export const TOP_EQUITY_FUNDS = 'TOP_EQUITY_FUNDS';
export const TOP_DEBT_FUNDS = 'TOP_DEBT_FUNDS';
export const TOP_ELSS_FUNDS = 'TOP_ELSS_FUNDS';
export const TOP_AGGRESSIVE_SIPS = 'TOP_AGGRESSIVE_SIPS';
export const TOP_SMALL_MIDCAP_FUNDS = 'TOP_SMALL_MIDCAP_FUNDS';
export const TOP_BALANCED_FUNDS = 'TOP_BALANCED_FUNDS';

export const TOP_FUNDS_SECTIONS = [
  TOP_EQUITY_FUNDS,
  TOP_ELSS_FUNDS,
  TOP_BALANCED_FUNDS,
  TOP_DEBT_FUNDS,
  TOP_AGGRESSIVE_SIPS,
  TOP_SMALL_MIDCAP_FUNDS,
];

export const TOP_FUNDS_STATIC = {
  equityTitle: 'Equity funds',
  debtTitle: 'Debt funds',
  elssTitle: 'ELSS funds',
  smallMidTitle: 'Small & Mid Cap',
  balancedTitle: 'Balanced funds',
  sipsTitle: 'Aggressive SIPs',
  title: `Top-performing selectedTab Funds`,
  subTitle: `Now invest in the safest and highest-performing selectedTab of your choice. Ideal for people looking to get risk-free returns.`,
  equity: [
    {
      title: 'Invest in mutual funds starting as low as ₹500',
    },
    {
      title:
        'We do the research for you and offer only the best equity funds in India',
    },
    {
      title:
        'Equity funds offer high returns at lower risk compared to stock market',
    },
    {
      title:
        'Suggested investment horizon of 5 years to reap the market-beating returns of these funds',
    },
    {
      title:
        'Equity funds invest in shares of companies based on market value. Invest in large, mid or small cap funds based on your preferences',
    },
  ],
  debt: [
    {
      title: 'Invest in mutual funds starting as low as ₹500',
    },
    {
      title:
        'We do the research for you and offer only the best debt funds in India',
    },
    {
      title:
        'Debt funds give you returns higher than bank FD, RD & Savings Account',
    },
    {
      title: 'They are less risky as they invest in fixed income securities',
    },
    {
      title:
        'Withdraw money invested in debt funds anytime as with bank accounts',
    },
  ],
  elss: [
    {
      title: 'Best ELSS (Tax-Saver) funds for you to invest in',
    },
    {
      title:
        'ELSS or Equity Linked Savings Schemes can save you upto ₹46,800 in taxes',
    },
    {
      title:
        'Get high returns on your investment along with great tax benefits',
    },
    {
      title: 'Lock-in period of just 3 years - lowest among other 80C options',
    },
    {
      title:
        'Invest as low as ₹500  monthly in SIP and avoid last minute tax-saving hassle',
    },
  ],
  smallMid: [
    { title: 'Invest as low as ₹500 every month' },
    {
      title:
        'Ideal for investors who seek high returns and willingness to take risk',
    },
    { title: 'Suitable for long-term investing - 5 or more years' },
    {
      title:
        'Mid-cap funds invest in the equity of emerging mid-sized companies',
    },
    {
      title:
        'Small-cap funds invest in equity of high-potential small-sized companies',
    },
  ],
  balanced: [
    { title: 'Invest as low as ₹500 every month' },
    { title: 'We offer only the best hybrid funds in India' },
    { title: 'Ideal for investors who prefer higher returns at lower risk' },
    { title: 'Suggest investing for up to 5 years' },
    { title: 'Hybrid funds invest in both equity and debt investments' },
  ],
  sips: [
    { title: 'Start small monthly investments - as low as Rs 500' },
    { title: 'Invest only in the best mutual funds suitable for SIP' },
    { title: 'Higher possible returns compared to Bank RD' },
    {
      title:
        'Invest throughout the year and get the best cost per unit of mutual fund',
    },
    {
      title: 'Avoid investing all your money during major market fluctuations',
    },
  ],
};

export const TOP_FUNDS_DROPDOWN = [
  {
    label: 'Top Equity Funds',
    key: 'TOP_EQUITY_FUNDS',
  },
  {
    label: 'Top ELSS Funds',
    key: 'TOP_ELSS_FUNDS',
  },
  {
    label: 'Top Balanced Funds',
    key: 'TOP_BALANCED_FUNDS',
  },
  {
    label: 'Top Debt Funds',
    key: 'TOP_DEBT_FUNDS',
  },
  {
    label: 'Top Aggressive SIPS',
    key: 'TOP_AGGRESSIVE_SIPS',
  },
  {
    label: 'Top Small & Midcap Funds',
    key: 'TOP_SMALL_MIDCAP_FUNDS',
  },
];

export const returnsLabels = {
  return1yr: '1 Year',
  return3yr: '3 Years',
  return5yr: '5 Years',
  return10yr: '10 Years',
};

export const randomColors = [
  '#FF8D1A',
  '#1AB3FF',
  '#FFE433',
  '#16D916',
  '#FF4F6D',
  '#AE5D29',
];

export const reviews = [
  {
    review:
      'Great investing experience! Contacted the support with queries.. Got immediate response and all my doubts clarified. Will definitely recommend ClearTax to friends',
    author: {
      image:
        'https://cdn2.iconfinder.com/data/icons/ios-7-icons/50/user_male2-512.png',
      name: 'Harish',
      identity: 'IT Developer, Bangalore',
    },
  },
  {
    review:
      'I am new to investments and got all the information I need on your website. The suggestions for mutual fund investments and tax savings are great.',
    author: {
      image:
        'https://cdn2.iconfinder.com/data/icons/ios-7-icons/50/user_male2-512.png',
      name: 'Prateek',
      identity: 'Software Engineer, Indore',
    },
  },
  {
    review:
      'Investing through ClearTax is super easy and simple. It is extremely helpful for investors with less finance knowledge.',
    author: {
      image:
        'https://cdn2.iconfinder.com/data/icons/ios-7-icons/50/user_male2-512.png',
      name: 'Rahul',
      identity: 'Campus Manager, Bangalore',
    },
  },
  {
    review:
      'Can easily invest at anytime, anywhere on ClearTax. Way to go ClearTax!',
    author: {
      image:
        'https://cdn2.iconfinder.com/data/icons/ios-7-icons/50/user_male2-512.png',
      name: 'Maya',
      identity: 'Hospitality Professional, Himachal Pradesh',
    },
  },
];

export const easyStepsData = [
  'Select amount to invest',
  'Enter Personal Details',
  'Pay and your are done!',
];

export const fundMetaDataMap = {
  isinCode: {
    label: 'ISIN',
  },
  risk: {
    label: 'Risk',
  },
  fundType: {
    label: 'Fund Type',
  },
  idealInvestmentDuration: {
    label: 'Ideal Investment Duration',
  },
  nav: {
    label: 'NAV',
    formatter: (value: any) => {
      if (isNaN(value)) {
        return value;
      }
      return `Rs. ${parseFloat(value).toFixed(2)}`;
    },
  },
  aum: {
    label: 'AUM',
    desc: '(As on Jan 31, 2018)',
  },
  lockInPeriod: {
    label: 'Lock in',
  },
  expenseRatio: {
    label: 'Expense Ratio',
  },
  exitLoad: {
    label: 'Exit Load',
    desc: '(Redemption within 365 days)',
    formatter: (value: any) => {
      if (value.percentage.toString() === '0') {
        return 'No Exit Load';
      }
      return `${value.percentage}% for ${value.days} ${
        Number(value.days) === 1 ? 'day' : 'days'
      }`;
    },
  },
};

export const subNavItems = [
  {
    value: 'summary',
    label: 'Plan Summary',
  },
  {
    value: 'fund-summary',
    label: 'Fund Summary',
  },
  {
    value: 'why-cleartax',
    label: 'Why Cleartax',
  },
  {
    value: 'recommended',
    label: 'Recommended Plans',
  },
  {
    value: 'faq',
    label: 'FAQs',
  },
];

export const accordionItems = [
  {
    value: 'summary',
    label: 'Plan Summary',
  },
  {
    value: 'fund-summary',
    label: 'Fund Summary',
  },
  {
    value: 'customer-reviews',
    label: 'Customer Reviews',
  },
  {
    value: 'why-cleartax',
    label: 'Why Cleartax Invest?',
  },
  {
    value: 'recommended',
    label: 'Other Recommended Plans',
  },
  {
    value: 'related-articles',
    label: 'Related Articles',
  },
  {
    value: 'faq',
    label: 'Frequently Asked Questions',
  },
];

export const accordionItemsForVariant = [
  {
    value: 'estimate-returns',
    label: 'Estimate Returns',
  },
  {
    value: 'summary',
    label: 'Plan Summary',
  },
  {
    value: 'fund-summary',
    label: 'Fund Summary',
  },
  {
    value: 'customer-reviews',
    label: 'Customer Reviews',
  },
  {
    value: 'why-cleartax',
    label: 'Why Cleartax Invest?',
  },
  {
    value: 'recommended',
    label: 'Other Recommended Plans',
  },
  {
    value: 'related-articles',
    label: 'Related Articles',
  },
  {
    value: 'faq',
    label: 'Frequently Asked Questions',
  },
];

export const whyCleartax = [
  'Our experts do all the research and offer only the BEST mutual funds',
  'Trusted by Over 25 Lakh Indians',
  'Invest in just 5 minutes',
  'No paperwork required',
  'Simple and easy to use',
];

export const investNowCaption = [
  'Invest in 5 minutes',
  'Zero Paperwork. Completely Online',
  'Only the best mutual funds to select from',
  'Netbanking and Debit Cards Accepted',
];

export const elssComparisonTable = [
  [
    { value: '' },
    { value: 'Tax Saving FD' },
    { value: 'PPF' },
    { value: 'ELSS' },
  ],
  [
    {
      value: 'Average Annualised Returns',
      info: 'Average return per year. Actual Returns may differ',
      place: 'right',
    },
    { value: '6%' },
    { value: '8%' },
    { value: '12%' },
  ],
  [
    {
      value: 'Tax rates',
      info: 'Assuming highest tax slab of 30% tax on taxable income',
      place: 'right',
    },
    { value: '30%' },
    { value: 'Not taxable' },
    { value: '10%*' },
  ],
  [
    {
      value: 'Returns after tax',
      info: 'Returns you get after subtracting the tax amount',
      place: 'right',
    },
    { value: '4.2%' },
    { value: '8.00%' },
    { value: '10.80%' },
  ],
  [
    {
      value: 'Current rate of Inflation',
      info: 'Inflation is a sustained increase in the general price level of goods and services. For example, what you can buy for Rs 100 today, will cost you Rs 104 after a year',
      place: 'right',
    },
    { value: '4%' },
    { value: '4%' },
    { value: '4%' },
  ],
  [
    {
      value: 'Real Rate of Return',
      info: 'Actual benefit you get for your investment after accounting for taxes and inflation',
      place: 'right',
    },
    { value: '0.2%' },
    { value: '4.00%' },
    { value: '6.80%' },
  ],
  [
    {
      value: 'Lock-in Period',
      info: 'Time duration for which you can not withdraw your money. You will be able to withdraw your money after the lock-in period',
      place: 'right',
    },
    { value: '5 years' },
    { value: '15 years' },
    { value: '3 years' },
  ],
];
export const SUBTYPE_MAPPING = {
  ELSS: 'ELSS',
  LargeCap: 'Equity',
  SmallCap: 'Equity',
  MidCap: 'Equity',
  MultiCap: 'Equity',
  Liquid: 'Liquid',
  EquityOriented: 'Hybrid',
  UltraShortTerm: 'Debt',
  DynamicBond: 'Debt',
  Income: 'Debt',
  CreditOpportunities: 'Debt',
  ShortTerm: 'Debt',
  GiltShortTerm: 'Debt',
};

export const TABLE_HEADER_SEARCH = [
  {
    title: 'Fund Name',
    className: 'large-3 small-7',
    sortKey: 'fundName',
  },
  {
    title: '3 Yr Returns',
    className: 'large-2 desktop-only pl0',
    sortKey: 'return3yr',
  },

  {
    title: '5 Yr Returns',
    className: 'large-2 small-3 pl0 pr0',
    sortKey: 'return5yr',
  },
  {
    title: 'Min SIP',
    className: 'large-2 desktop-only',
    sortKey: 'minSipAmount',
  },
  {
    title: '',
    className: 'large-3 small-2',
  },
];

export const AMC_FUND_LIST_HEADER_SEARCH = [
  {
    title: 'Fund Name',
    className: 'large-5 small-7',
  },
  {
    title: 'Risk',
    className: 'large-2 small-3 pl20 desktop-only',
  },
  {
    title: '3 Yr Returns',
    className: 'large-2 small-3 pl0 pr0',
  },
  {
    title: 'Rating',
    className: 'large-1 small-3 center desktop-only',
  },
  {
    title: '',
    className: 'large-2 small-2',
  },
];

export const AMC_FUND_LIST_HEADER_SEARCH_NEW = [
  {
    title: 'FUND',
    className: 'large-5 small-7',
  },
  {
    title: 'Min. investment',
    className: 'large-2 small-3 pl20 desktop-only',
  },
  {
    title: 'Risk',
    className: 'large-2 small-3 pl20 desktop-only',
  },
  {
    title: 'Rating',
    className: 'large-1 small-3 center desktop-only',
  },
];

export const NFO_FILTER_LIST = [
  {
    label: 'All',
    key: 'all',
  },
  {
    label: 'Live',
    key: 'liveNfos',
  },
  {
    label: 'Closed',
    key: 'closedNfos',
  },
  {
    label: 'Upcoming',
    key: 'upcomingNfos',
  },
];

export const NFO_HEADER_LIST = [
  {
    title: 'Fund NAME',
    className: 'large-4 small-7',
    textClass: 'lil-text-s-12',
  },
  {
    title: 'STATUS',
    className: 'large-2 small-3 pl20 sm:lil-hidden',
    textClass: 'lil-text-s-12',
  },
  {
    title: 'MIN. Investment',
    className: 'large-2 small-3 pl20',
    textClass: 'lil-text-s-12',
  },
  {
    title: 'LAUNCH DATE',
    className: 'large-2 small-3 center sm:lil-hidden',
    textClass: 'lil-text-s-12',
  },
  {
    title: 'CLOSE DATE',
    className: 'large-2 small-3 center sm:lil-hidden',
    textClass: 'lil-text-s-12',
  },
];

export const ACCOUNT_TYPE_MAP = {
  Savings: 'SB',
  Current: 'CA',
  SB: 'SB',
  CA: 'CA',
};

export const KYC_STATUS = {
  VERIFIED: 'VERIFIED',
  NOT_VERIFIED: 'NOT_VERIFIED',
  NOT_KNOWN: 'NOT_KNOWN',
  UNDER_PROCESS: 'UNDER_PROCESS',
  THIRD_PARTY_FAILURE: 'THIRD_PARTY_FAILURE',
  UNABLE_TO_CHECK: 'UNABLE_TO_CHECK',
};

export const SIP_FAQ = [
  {
    question: 'What are the benefits of investing in SIP?',
    answer: {
      preText:
        'The benefits of investing in mutual funds through SIPs are as follows:',
      points: [
        '**Instils financial discipline: ** As SIP requires investors to invest periodically, it forces you to set aside a fixed sum. Investors unknowingly become financially disciplined by opting to invest through SIPs. ',
        '**No need to time markets: **  SIPs are designed such that you don’t need to have prior knowledge of markets, removing the need to time the markets.',
        '**Advantage of rupee cost averaging: ** As the amount invested is constant, investors buy more fund units when the markets go down and fewer units when the markets are rallying. The average cost of the units is lower.',
        '**Simple and easy to invest: ** Investors can initiate ECS on their savings/current accounts or give their bankers a standing instruction to automatically invest in mutual funds via SIP. This makes the investment process easier for investors. ',
        '**The benefit of starting early: ** The key to growing your wealth is to start early and make regular investments. With SIPs, the minimum amount required to start an investment is as low as Rs 500 a month. This makes investing a lot easier for first-time investors. ',
      ],
    },
  },
  {
    question: 'How does SIP Calculator work?',
    answer:
      'SIP returns are calculated according to compound interest. Enter the amount you wish to invest every month, choose the number of years you wish to continue the investment for, and our calculator will automatically calculate the amount of return. It will also show you a comparative study of your SIP return vs other investment options like Fixed Deposits.',
  },
  {
    question: 'How to invest in SIP?',
    answer:
      'You can make monthly investments to your SIP account. Or, you can link it to your bank account to ensure that the deductions are made automatically.',
  },
  {
    question: 'How long should I invest in SIP?',
    answer:
      'There is no rule of thumb that dictates how long an SIP investment should be. However, on an average, a SIP for four years and above runs a low risk of loss. Short-term investments generally have higher returns but also come with a high risk of loss.',
  },
  {
    question: 'Is SIP safer than lumpsum investments?',
    answer:
      'Yes! The investment market is generally volatile, and a lumpsum investment comes with the added risk of loss. Instead, it is always better to invest in SIPs. If the markets are high, you buy fewer units of the fund and if the markets are low, you buy more units for the same amount. This helps you ride out the volatility and earn better returns.',
  },
  {
    question: 'What are the best fund schemes to invest in SIP?',
    answer: {
      preText: ' ',
      points: [
        `[ELSS](https://cleartax.in/s/elss) and [Equity Funds](https://cleartax.in/s/equity-funds) are one of the best fund schemes to invest in SIP. Amount invested in ELSS is exempted from taxable income under Section 80C. Equity Funds generally provide high returns and are a great investment option if you are looking to make profits.`,
      ],
    },
  },
];

export const SIP_FAQ_V2 = [
  {
    question: 'How does ClearTax SIP Calculator help you choose SIPs',
    answer:
      'The ClearTax SIP Calculator shows you the value of your investment after a certain number of years. You have to enter the amount you intend to invest as a SIP instalment. You may consider filling up the expected rate of return and the period you plan to invest in the SIP. The ClearTax SIP Calculator shows you the value of the investment at the end of the SIP tenure. You may enter different SIP instalments in the calculator to calculate the maturity value of your investment. You could also use the ClearTax SIP Calculator to select your SIP instalments depending on your financial goals.',
  },
  {
    question:
      'Why does ClearTax SIP Calculator ask for the investment duration for SIP?',
    answer: {
      preText: ' ',
      points: [
        'You may consider entering the investment duration of your SIP in years, in the ClearTax SIP Calculator. The calculator will display the value of your investment at the end of the SIP tenure. You must enter both the SIP instalments and the duration of the investment, for the ClearTax SIP Calculator to show you the maturity value of your investment.',
        'SIP investors invest a fixed amount (SIP instalments) at regular intervals over a period called investment duration. The ClearTax SIP Calculator shows the value of the investment at the end of the SIP tenure. You must enter the investment duration of SIP so that the calculator can show you the value of your investment over some time. You could choose an investment duration in-line with the time you expect to achieve your financial objectives.',
      ],
    },
  },
  {
    question:
      'Why does the ClearTax SIP Calculator ask for the expected annual returns?',
    answer:
      'When it comes to market-linked investments, no investment is safe. However, when it comes to mutual funds, SIPs keep volatility at bay. SIPs do not circumvent losses as it completely depends on the market condition.',
  },
  {
    question: 'Are SIPs mutual funds?',
    answer: {
      preText: ' ',
      points: [
        'You may consider entering the expected annual return from SIP instalments in the ClearTax SIP Calculator. The calculator will show you the value of your investment at the end of the SIP tenure, based on the expected annual return from the investment. For example, if you enter a higher expected annual return, you could achieve your financial goals with a lower investment duration. ',
        'You could enter a higher expected annual return if you intend to attain financial goals sooner than expected. However, it would be better to enter a reasonable expected annual return in the ClearTax SIP Calculator. It gives a true picture of the time you have to achieve your investment objectives. ',
      ],
    },
  },
  {
    question: 'Can I use ClearTax SIP Calculator for lump sum investments?',
    answer:
      'You may consider using the ClearTax SIP Calculator only to calculate the value of SIP instalments at the end of the SIP tenure (investment duration). SIP and lump sum are two different modes of investment in mutual fund schemes. You could use the ClearTax Mutual Fund Calculator where you select the one-time investment (lump sum) to calculate the expected amount at maturity. ',
  },
  {
    question: 'Why should I use the ClearTax SIP Calculator?',
    answer: {
      preText: ' ',
      points: [
        'The ClearTax SIP Calculator will show you the value of your SIP instalments at the end of the investment tenure. All you must do is enter the SIP instalment, investment duration, and the expected annual rate of return.  The calculator will display the value of your investment at the end of the SIP tenure. ',
        'You may use the ClearTax SIP Calculator to get a birds-eye view of your mutual fund investments. It helps you to decide on your SIP instalments to achieve your financial goals in time. ',
      ],
    },
  },
  {
    question: 'Is ClearTax SIP Calculator easy to use?',
    answer: {
      preText: ' ',
      points: [
        'Well, you could use the ClearTax SIP Calculator from the comfort of your home or anywhere. It helps you calculate the value of your SIP instalments at the end of the SIP tenure. You may consider using the ClearTax SIP Calculator to determine if your mutual fund investments could offer an inflation-beating return.',
        'You may consider using the ClearTax SIP Calculator to estimate the value of SIP instalments at the end of the investment period. You could align your mutual fund investments to match your risk tolerance and achieve your investment objectives.',
      ],
    },
  },
  {
    question:
      'How can the ClearTax SIP Calculator help me achieve my financial goals?',
    answer: {
      preText: ' ',
      points: [
        'You may consider picking a mutual fund scheme based on your risk tolerance. You then decide on an ideal investment duration to achieve your financial goals. For example, you may select a 15-year investment duration if you are investing for your children’s higher education.',
        'You could choose a SIP instalment amount you are comfortable with. You may consider entering different annual expected returns in the ClearTax SIP Calculator. It shows you the investment value at the end of the SIP tenure, based on your SIP instalments and expected return on investment. ',
      ],
    },
  },
];

export const BEST_SIP_EQUITY = [
  {
    fundName: 'Axis Bluechip Fund',
    return3yr: '16.96',
    investLink: '/mutual-funds/axis/axis-bluechip-fund/INF846K01164?ref=search',
  },
  {
    fundName: 'SBI Magnum Multicap Fund',
    return3yr: '12.83',
    investLink: '/mutual-funds/sbi/sbi-magnum-multicap/INF200K01222?ref=search',
  },
  {
    fundName: 'Mirae Asset Large Cap Fund',
    return3yr: '12.51',
    investLink:
      '/mutual-funds/mirae-asset/mirae-asset-large-cap-fund/INF769K01010?ref=search',
  },
  {
    fundName: 'ICICI Prudential Bluechip Fund',
    return3yr: '12.37',
    investLink:
      '/mutual-funds/icici-prudential/icici-prudential-bluechip/INF109K01BL4',
  },
  {
    fundName: 'SBI Bluechip Fund',
    return3yr: '11.41',
    investLink: '/mutual-funds/sbi/sbi-bluechip-fund/INF200K01180?ref=search',
  },
];

export const BEST_SIP_DEBT = [
  {
    fundName: 'Aditya Birla Sun Life Savings Fund',
    return3yr: '7.83',
    investLink:
      '/mutual-funds/birla-sun-life/aditya-bsl-savings-fund/INF209K01LZ1',
  },
  {
    fundName: 'HDFC Short Term Debt Fund',
    return3yr: '7.83',
    investLink: '/mutual-funds/hdfc/hdfc-short-term-debt-fund/INF179K01CU6',
  },
  {
    fundName: 'Nippon India Low Duration Fund',
    return3yr: '7.06',
    investLink: '/mutual-funds/nippon/nippon-india-low-duration/INF204K01EV6',
  },
  {
    fundName: 'Aditya Birla Sun Life Credit Risk Fund',
    return3yr: '6.75',
    investLink:
      '/mutual-funds/birla-sun-life/aditya-bsl-credit-risk/INF209KA1K47',
  },
  {
    fundName: 'L&T Low Duration Fund',
    return3yr: '6.74',
    investLink: '/mutual-funds/lt/l-t-low-duration/INF677K01452',
  },
];

export const personalDetailsFaq = [
  {
    question: 'Why should I do KYC?',
    answer: {
      preText: ' ',
      points: [
        `KYC or Know Your Customer verification is mandatory as per SEBI regulations for any Mutual Fund investment in India. A person has to full KYC verification ** _within the next 24-48 hours_ ** of Mutual Fund investment. Your fund(s) ** _will not_ ** be allocated and investment will be rejected by the Fundhouse if your KYC is not verified within 48 hours of making an investment.`,
      ],
    },
  },
  {
    question: 'How should I do KYC?',
    answer: {
      preText: `KYC is a one-time activity that one can be completed by sending us the documents. The requirements for KYC are :`,
      points: [
        `Completed correct personal information (KYC Details)`,
        `A photocopy of Address Proof`,
        `A photocopy of PAN Card`,
        `A clear photograph`,
        `Please note doing a KYC on ClearTax is ** _completely free._ **`,
      ],
    },
  },
  {
    question: 'How long does it take to do KYC?',
    answer: `A KYC can take upto 2 weeks after you have sent all the required documents to us.

However, once you have sent all the documents, you don’t have to worry since ClearTax will complete the process on your behalf.

We will ensure that your investment gets completed as long as you sent complete documents within 24-48 hours of making an investment.`,
  },
  //   {
  //     question: 'Should I do an eKYC or full KYC?',
  //     answer: `If you have linked your Aadhaar Number to your phone, you can do an eKYC instantly.
  // However, if you don’t have an Aadhaar linked phone number you can go for full KYC.`,
  //   },
  {
    question: 'Do I have to do a KYC again?',
    answer: {
      preText: ' ',
      points: [
        `Once you have done a **full KYC**, you don’t have to worry about a KYC again.`,
      ],
    },
  },
];

export const variantsField = {
  name: 'variants',
  type: 'select',
  isInvalid: false,
  required: false,
  hideEmpty: true,
  labelName: '',
  id: 'variants',
};

export const ELSS_POINTS = [
  {
    icon: 'star.svg',
    text: 'Save up to Rs 46,800 in taxes every year.',
  },
  {
    icon: 'high-returns.svg',
    text: 'Highest returns compared to other 80C investments.',
  },
  {
    icon: 'paper.svg',
    text: 'Lowest lock-in of 3 years',
  },
];
export const ELSS_POINTS_VARIANT_B = [
  {
    icon: 'star.svg',
    text: 'Expert Picked Tax Savings Plan',
  },
  {
    icon: 'high-returns.svg',
    text: 'Basket of High Quality Funds',
  },
  {
    icon: 'paper.svg',
    text: 'Enjoy highest returns and lowest lock-in among all tax saving options',
  },
];

export const RECOMMENDED_ARTICLES = [
  {
    link: '/s/elss',
    title: 'Learn about ELSS Investments',
    subtitle: 'Invest in ELSS Tax Saving Mutual Funds to save taxes.',
  },

  {
    link: '/s/80c-80-deductions',
    title: 'Learn about tax deductions - 80C',
    subtitle: 'Tax Deductions Section 80C, 80CCC & 80CCD and more.',
  },
  {
    link: '/s/mutual-funds',
    title: 'Learn about Mutual Funds',
    subtitle: 'Investing in Mutual Funds Types, benefits, how to invest',
  },
];

export const INVESTMENT_OWNER_LIST = [
  {
    key: 'SELF',
    value: 'Self',
  },
  // {
  //   key: 'SPOUSE',
  //   value: 'Spouse',
  // },
  // {
  //   key: 'DEPENDENT_CHILDREN',
  //   value: 'Dependent Children',
  // },
  // {
  //   key: 'DEPENDENT_PARENTS',
  //   value: 'Dependent Parents',
  // },
];

export const PAYMENT_PROVIDER = {
  mandate: 'MANDATE',
  link: 'PAYMENT_LINK',
};

export * from './tooltipData';

export * from './homePageData';
export * from './userFields';
export * from './errorCodes';
export * from './recommendationData';
export * from './footerLinks';



// WEBPACK FOOTER //
// ./constants/index.ts